import { render, staticRenderFns } from "./DemoMind524.vue?vue&type=template&id=35d770df&scoped=true&"
import script from "./DemoMind524.vue?vue&type=script&lang=js&"
export * from "./DemoMind524.vue?vue&type=script&lang=js&"
import style0 from "./DemoMind524.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DemoMind524.vue?vue&type=style&index=1&id=35d770df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d770df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
